import { render, staticRenderFns } from "./ConfiguracionClasesPrograma.vue?vue&type=template&id=06d951ec&scoped=true"
import script from "./ConfiguracionClasesPrograma.vue?vue&type=script&lang=js"
export * from "./ConfiguracionClasesPrograma.vue?vue&type=script&lang=js"
import style0 from "./ConfiguracionClasesPrograma.vue?vue&type=style&index=0&id=06d951ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d951ec",
  null
  
)

export default component.exports